import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

export interface DeleteLinkTilePayload {
    readonly uid: string;
}

/**
 * Removes a tile for good. The removal is HARD, not a flag: the recycle bin is
 * a fixed list of restorable types, so a soft-deleted tile would be either
 * invisible and unrestorable, or restorable under a page that no longer exists.
 */
export class DeleteLinkTileCommand extends AbstractCommand<DeleteLinkTilePayload> {

    public name = CommandName.DELETE_LINK_TILE;

    public tags: string[] = [`entity`, `delete`, `link-tile`];

    constructor(payload: DeleteLinkTilePayload) {
        super('link-tile', payload.uid, payload);
    }
}
